<template>
    <section>
        <form-my-share></form-my-share>
    </section>
</template>

<script>
import formMyShare from "@/components/form_custom/my/share";

export default {
    data() {
        return {
            
           
        };
    },

    components: {
        formMyShare,
    },
    computed: {},

    methods: {
    },

    mounted() {},
};
</script>

<style scoped lang="scss">

section{
    padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/approvals/my/share.vue